export function getBrandBadgeClass(brand: string) {
  const brandLower = (brand || '').toLowerCase().trim();
  if (brandLower.includes('homes for students') || brandLower === 'hfs') return 'brand-badge-hfs';
  if (brandLower.includes('prestige')) return 'brand-badge-psl';
  if (brandLower.includes('essential')) return 'brand-badge-esl';
  if (brandLower.includes('urban') || brandLower.includes('student life')) return 'brand-badge-usl';
  return `brand-badge-custom-${brandLower.replace(/[^a-z0-9]/g, '-')}`;
}

